/**
 * LocationOutlineIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const LocationOutlineIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M12 7.018a2.9 2.9 0 0 1 2.9 2.9v.037a2.9 2.9 0 0 1-2.9 2.9 2.9 2.9 0 0 1-2.9-2.9l.002-.018-.002-.019a2.9 2.9 0 0 1 2.9-2.9m0 1.8a1.1 1.1 0 0 0-1.1 1.1l-.002.019.002.018a1.099 1.099 0 1 0 2.2 0v-.037a1.1 1.1 0 0 0-1.1-1.1"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12 2.1a7.774 7.774 0 0 1 7.773 7.773v.172c0 1.04-.325 2.145-.788 3.205-.466 1.07-1.098 2.155-1.774 3.172-1.013 1.524-2.15 2.934-3.033 3.964l-.784.892c-.7.777-1.882.826-2.642.146l-.146-.146c-.896-.994-2.466-2.823-3.817-4.856-.676-1.017-1.308-2.102-1.774-3.172-.463-1.06-.788-2.165-.788-3.205v-.172A7.774 7.774 0 0 1 12 2.1m0 1.8a5.97 5.97 0 0 0-5.973 5.973v.172c0 .69.222 1.535.637 2.486.41.941.984 1.93 1.624 2.894 1.281 1.927 2.785 3.683 3.655 4.648.032.035.081.036.113.001.87-.966 2.375-2.722 3.656-4.65.64-.963 1.214-1.951 1.624-2.893.415-.951.637-1.796.637-2.486v-.172A5.97 5.97 0 0 0 12 3.9"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const LocationOutlineIcon = makeIcon('LocationOutlineIcon', LocationOutlineIconSvg)
